// extracted by mini-css-extract-plugin
export var compareActions = "index-module--compareActions--4TOMA";
export var comparisonSlider = "index-module--comparisonSlider--qzwlT";
export var imageComparisonHeader = "index-module--imageComparisonHeader--8jBDT";
export var imageComparisonSliderContainer = "index-module--imageComparisonSliderContainer--YVIYK";
export var imageComparisonWrapper = "index-module--imageComparisonWrapper--eNzuS";
export var leftImage = "index-module--leftImage--cmpIl";
export var leftImageDesc = "index-module--leftImageDesc--ITlQd";
export var rightImage = "index-module--rightImage--QSuq5";
export var rightImageDesc = "index-module--rightImageDesc--g2H9J";